import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_WHD_FORMS_ACCOUNT_SUCCESS = 'GET_WHD_FORMS_ACCOUNT_SUCCESS';
export const GET_WHD_FORMS_ACCOUNT_REQUEST = 'GET_WHD_FORMS_ACCOUNT_REQUEST';
export const GET_WHD_FORMS_ACCOUNT_FAILURE = 'GET_WHD_FORMS_ACCOUNT_FAILURE';

function requestGetWhdForAccount() {
  return {
    type: GET_WHD_FORMS_ACCOUNT_REQUEST,
    isGettingWhdForAccount: true
  };
}

function rejectGetWhdForAccount() {
  return {
    type: GET_WHD_FORMS_ACCOUNT_FAILURE,
    isGettingWhdForAccount: false
  };
}

function receiveGetWhdForAccount(data) {
  return {
    type: GET_WHD_FORMS_ACCOUNT_SUCCESS,
    withholdingStatement: data,
    isGettingWhdForAccount: false
  };
}

export function getWhdStatementFromAccount(accountId) {
  return (dispatch) => {
    dispatch(requestGetWhdForAccount());
    const promise = () => ApiService
      .getAccountWithholdingStatements([accountId])
      .then((response) => {
        dispatch(receiveGetWhdForAccount(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectGetWhdForAccount, true));
        }
      });
    return promise();
  };
}
